'use strict';

const { h } = require('phy');

function getAdvert(adverts) {
  return adverts.find(advert => advert.leaderboard.leaderboardPosition === 0);
}

function getMedia(medias) {
  return medias.find(media => media.isMainImage === true);
}

function getButtonTextColour({
  leaderboardTextColour,
  leaderboardButtonColour,
}) {
  return leaderboardButtonColour !== leaderboardTextColour
    ? `color: #${leaderboardTextColour}`
    : '';
}

function LeaderboardCallout({
  className = '',
  display,
  adverts = [],
  isTouch,
}) {
  if (!display || !adverts || !adverts.length || isTouch) {
    return null;
  }

  const callout = getAdvert(adverts);
  if (!callout || !Array.isArray(callout.media)) {
    return null;
  }

  const image = getMedia(callout.media);
  if (!image) {
    return null;
  }

  const size = 'w_1056,h_100,';

  const {
    id,
    destination,
    leaderboard: {
      title,
      message,
      leaderboardButtonText,
      leaderboardTextColour,
      leaderboardButtonColour,
    },
  } = callout;

  const textStyle = `color: #${leaderboardTextColour}`;
  const buttonStyle = `background-color: #${leaderboardButtonColour}`;
  const buttonTextStyle = getButtonTextColour({
    leaderboardTextColour,
    leaderboardButtonColour,
  });

  return h(
    '.row',
    h(
      '.twelve.columns',
      h(
        `section.leaderboard-callout.${className}`,
        {
          'data-bhw': `leaderboard:${id}`,
          style: {
            'background-image': `url('${image.mediaUrl.replace(
              '{{options}}',
              size
            )}')`,
          },
        },
        h('div.leaderboard-callout-text', [
          h('span.leaderboard-callout-title', { style: textStyle }, title),
          h('span.leaderboard-callout-subtitle', { style: textStyle }, message),
        ]),
        h(
          'a.button.leaderboard-callout-button',
          {
            'data-bhc': `callout:${id}`,
            href: destination,
            title,
            style: buttonStyle,
          },
          h(
            'span.leaderboard-callout-button-text',
            { style: buttonTextStyle },
            leaderboardButtonText
          )
        )
      )
    )
  );
}

module.exports = LeaderboardCallout;
